export default function Card({children}) {
    return (
        <div style={{background: 'white', padding: '25px', boxShadow: '0px 10px 30px -5px rgb(0 0 0 / 10%)'}}>
            {children}
        </div>
    )
}